export default "__VITE_ASSET__b13f0a6e__"